module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1039-e922fd6ec318da28df197d2594045e38.png";